import { render, staticRenderFns } from "./crm-create-from-id.vue?vue&type=template&id=be0b36f8&"
import script from "./crm-create-from-id.vue?vue&type=script&lang=js&"
export * from "./crm-create-from-id.vue?vue&type=script&lang=js&"
import style0 from "./crm-create-from-id.vue?vue&type=style&index=0&id=be0b36f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports